import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'lumiron-card-title',
  templateUrl: 'card-title.component.html',
  styleUrl: './card-title.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
})
export class CardTitleComponent {}
